export default {
	MERCHANDISE: 'companies/:company_id/merchandise/'
}